/**
 * Disdetta - Fase 8
 *
 * Disdette sindacali, collegate al lavoratore.
 *
 * Tipi:
 * - INVIATA: FILCA manda disdetta ad altro sindacato (lavoratore viene da noi)
 * - RICEVUTA: altro sindacato ci manda disdetta (lavoratore lascia noi)
 * - GENERICO: disdetta generica (senza sigla sindacato specifico)
 */
import { z } from 'zod';
import { CassaCodeSchema, str } from './common.ts';

// Tipi disdetta
export const TIPI_DISDETTA = ['INVIATA', 'RICEVUTA', 'GENERICO'] as const;
export const TipoDisdettaSchema = z.enum(TIPI_DISDETTA);
export type TipoDisdetta = z.infer<typeof TipoDisdettaSchema>;

// Origini disdetta
export const ORIGINI_DISDETTA = ['MANUALE', 'IMPORT'] as const;
export const OrigineDisdettaSchema = z.enum(ORIGINI_DISDETTA);
export type OrigineDisdetta = z.infer<typeof OrigineDisdettaSchema>;

export const DisdettaSchema = z.object({
  id: z.number(),
  lavoratoreId: z.number(),
  cassa: CassaCodeSchema,
  tipo: TipoDisdettaSchema,
  sigla: str,
  dataDisdetta: z.string(),
  note: str,
  operatore: str,
  createdAt: str,
  updatedAt: str,
  nascosta: z.number().default(0),
  delegaGenerataId: z.number().nullable().default(null),
  origine: OrigineDisdettaSchema.default('MANUALE'),
});

export type Disdetta = z.infer<typeof DisdettaSchema>;

// Per INSERT (senza id, timestamp e campi auto-gestiti).
// `operatore` resta nel DB (storico import) ma non e' piu' scrivibile:
// la disdetta non ha un operatore che la registra.
export const DisdettaInsertSchema = DisdettaSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  nascosta: true,
  delegaGenerataId: true,
  operatore: true,
});

export type DisdettaInsert = z.infer<typeof DisdettaInsertSchema>;
